import { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../App";
import { CDN_URL, formatMoney } from "../Helpers";
import doctor_sample from '../assets/doctor_sample.jpg';
import { STR_PER_SESSION, STR_START_CHAT } from "../Strings";
import { FaUserDoctor } from "react-icons/fa6";

export default function View({ data, size = 'small' }) {
  const appContext = useContext(AppContext);

  /* Place states here */

  function openLogin() {
    appContext.navTo({
      item: 'view',
      subItem: 'login',
    })
  }
  
  function startChat() {
    if (appContext.currentUserData.subscriptionStatus === 'active') {
      appContext.navTo({
        item: 'view',
        subItem: 'chatroom',
        extraItem: data.id,
      })
    } else {
      appContext.tellPurchaseMessage();
    }

  }

  return (
    <div className="card OneDoctor">
      {
        (data.doctorPhoto) ?
        <img
          className="photo"
          src={CDN_URL+data.doctorPhoto}
        />
        :
        <h6
          style={{
            padding: "10px"
          }}
        >
          <FaUserDoctor size={60} className="text-muted"/>
        </h6>
      }
      <div className="card-body">

        {(data.doctorStatus === 'online') ? <span style={{ fontSize: "12px" }} className="font-bold text-success">Online</span> : ""}
        {(data.doctorStatus === 'offline') ? <span style={{ fontSize: "12px" }} className="font-bold text-danger">Offline</span> : ""}

        <div className="fullname font-bold mb-2">
          {data.doctorFullname}
        </div>

        <div className="role mb-2">
          <span className="badge bg-dark">{data.doctorRole}</span>
        </div>

        <div className="description mb-2">
          {
            (appContext.language === 'sw') ?
            data.doctorDescriptionSw
            :
            data.doctorDescription
          }
        </div>

        

        <div className="text-end">
          {
            (appContext.auth && appContext.currentUserData) ?

            <>
            {
              (Number(data.id) !== Number(appContext.currentUserData.id)) ?
                (data.doctorStatus === 'online') ?
                <button
                  className="btn btn-secondary btn-rounded btn-padded"
                  onClick={startChat}
                >
                  {STR_START_CHAT[appContext.language]}
                </button>
                : ""
              : ""
            }
            </>
            :
            <button
              className="btn btn-secondary btn-rounded btn-padded"
              onClick={openLogin}
            >
              {STR_START_CHAT[appContext.language]}
            </button>
          }
        </div>
      </div>
    </div>
  )
}
